import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './VideoSection.css';

export default function VideoSection() {
  useStyles(s);
  const videosInfo = [
    {
      src: 'https://static.tapsi.cab/careers/co-op.mp4',
    },
  ];

  return (
    <section>
      <h2>گپ و گفت با دانشجویان کوآپ شریف در تپسی</h2>
      <div>
        <div className={s.itemWrapper}>
          {videosInfo?.map((video) => (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video controls preload="auto">
              <source src={video.src} type="video/mp4" />
            </video>
          ))}
        </div>
      </div>
    </section>
  );
}
